export const FIND_EMPLOYEE_ROLE_SUCCESS = 'FIND_EMPLOYEE_ROLE_SUCCESS';

export const findEmployeeRoleSuccess = employeeRole => ({
    type: FIND_EMPLOYEE_ROLE_SUCCESS,
    payload: { employeeRole },
});
